import { useTranslation } from '@pancakeswap/localization'
import { Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { SearchTypeFilterItemText, SearchTypeFilterItemWrapper } from '../../styled'
import { filterMenuConfig } from '../filterConfig'

const Wrapper = styled(Flex)`
  display: flex;
  width: 128px;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`

interface TypeFilterProps {
  activeFilter: number
  onClickFilter: (index: number) => void
}

const TypeFilter = ({ activeFilter, onClickFilter }: TypeFilterProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      {filterMenuConfig.map((item, index) => {
        const Icon = item.icon
        return (
          <SearchTypeFilterItemWrapper key={item.label} onClick={() => onClickFilter(index)}>
            <Icon isActive={index === activeFilter} />
            <SearchTypeFilterItemText isActive={index === activeFilter}>{t(item.label)}</SearchTypeFilterItemText>
          </SearchTypeFilterItemWrapper>
        )
      })}
    </Wrapper>
  )
}

export default TypeFilter
